import { useState } from 'react';
import { Form, Button, Row, Col, Badge, Collapse } from 'react-bootstrap';
import { Funnel, XLg } from 'react-bootstrap-icons';
import { states, accidentTypes } from '../../data/mockLeads';

export function FilterSidebar({ filters, setFilters, onClear }) {
  const [isOpen, setIsOpen] = useState(false);
  const [tempFilters, setTempFilters] = useState(filters);

  const hasActiveFilters = filters.state || filters.severityRange || filters.accidentType;

  const handleOpen = () => {
    setTempFilters(filters);
    setIsOpen(true);
  };

  const handleApply = () => {
    setFilters(tempFilters);
    setIsOpen(false);
  };

  const handleCancel = () => {
    setTempFilters(filters);
    setIsOpen(false);
  };

  const removeFilter = (filterKey) => {
    setFilters({ ...filters, [filterKey]: filterKey === 'severityRange' ? '' : '' });
  };

  const getSeverityLabel = (range) => {
    const labels = { '1-3': 'Low', '4-6': 'Medium', '7-10': 'High' };
    return labels[range] || range;
  };

  return (
    <div className="mb-3">
      <div className="d-flex align-items-center gap-2 flex-wrap">
        <Button
          variant={isOpen ? 'primary' : 'outline-secondary'}
          size="sm"
          onClick={() => isOpen ? handleCancel() : handleOpen()}
        >
          <Funnel size={14} className="me-1" />
          Filters
        </Button>

        {hasActiveFilters && !isOpen && (
          <>
            {filters.state && (
              <Badge bg="light" text="dark" className="d-flex align-items-center gap-1 py-2 px-2">
                {filters.state}
                <XLg size={10} style={{ cursor: 'pointer' }} onClick={() => removeFilter('state')} />
              </Badge>
            )}
            {filters.severityRange && (
              <Badge bg="light" text="dark" className="d-flex align-items-center gap-1 py-2 px-2">
                Severity: {getSeverityLabel(filters.severityRange)}
                <XLg size={10} style={{ cursor: 'pointer' }} onClick={() => removeFilter('severityRange')} />
              </Badge>
            )}
            {filters.accidentType && (
              <Badge bg="light" text="dark" className="d-flex align-items-center gap-1 py-2 px-2">
                {filters.accidentType}
                <XLg size={10} style={{ cursor: 'pointer' }} onClick={() => removeFilter('accidentType')} />
              </Badge>
            )}
            <Button variant="link" size="sm" onClick={onClear} className="text-muted p-0 ms-1">
              Clear all
            </Button>
          </>
        )}
      </div>

      <Collapse in={isOpen}>
        <div>
          <div className="filter-bar mt-2">
            <Row className="g-3">
              <Col xs={12} sm={6} md={4}>
                <Form.Label className="small text-muted mb-1">State</Form.Label>
                <Form.Select
                  size="sm"
                  value={tempFilters.state}
                  onChange={(e) => setTempFilters({ ...tempFilters, state: e.target.value })}
                >
                  <option value="">All States</option>
                  {states.map(state => (
                    <option key={state} value={state}>{state}</option>
                  ))}
                </Form.Select>
              </Col>

              <Col xs={12} sm={6} md={4}>
                <Form.Label className="small text-muted mb-1">Accident Type</Form.Label>
                <Form.Select
                  size="sm"
                  value={tempFilters.accidentType || ''}
                  onChange={(e) => setTempFilters({ ...tempFilters, accidentType: e.target.value })}
                >
                  <option value="">All Types</option>
                  {accidentTypes.map(type => (
                    <option key={type} value={type}>{type}</option>
                  ))}
                </Form.Select>
              </Col>

              <Col xs={12} sm={6} md={4}>
                <Form.Label className="small text-muted mb-1">Severity</Form.Label>
                <Form.Select
                  size="sm"
                  value={tempFilters.severityRange || ''}
                  onChange={(e) => setTempFilters({ ...tempFilters, severityRange: e.target.value })}
                >
                  <option value="">Any</option>
                  <option value="1-3">1-3 (Low)</option>
                  <option value="4-6">4-6 (Medium)</option>
                  <option value="7-10">7-10 (High)</option>
                </Form.Select>
              </Col>
            </Row>

            <div className="d-flex gap-2 mt-3">
              <Button variant="primary" size="sm" onClick={handleApply}>
                Apply Filters
              </Button>
              <Button variant="outline-secondary" size="sm" onClick={handleCancel}>
                Cancel
              </Button>
            </div>
          </div>
        </div>
      </Collapse>
    </div>
  );
}
